import { render } from "./PurchaseDynamic.vue?vue&type=template&id=4b513d8a&scoped=true"
import script from "./PurchaseDynamic.vue?vue&type=script&lang=js"
export * from "./PurchaseDynamic.vue?vue&type=script&lang=js"

import "./PurchaseDynamic.vue?vue&type=style&index=0&id=4b513d8a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b513d8a"]])

export default __exports__